<hawk-record-navigation
  class="app-page"
  [breadcrumbLinkList]="[{ description: 'Filialen', link: '/a/filiale' }]"
  [root]="'store'"
  [leafDescription]="'Neue Filiale'"
>
  <div slot="toolbar" class="flex flex-row gap-2 items-center"></div>
  <div class="page-content px-4 pb-2 overflow-auto">
    <form [formGroup]="storeForm" class="page-sheet max-w-7xl mx-auto grid grid-cols-3" (submit)="onSubmit()">
      <fieldset class="bm-fieldset p-4">
        <legend class="bm-fieldset-legend text-lg">Stammdaten</legend>
        <ng-container [ngTemplateOutlet]="tplStammdaten" />
      </fieldset>
      <fieldset class="bm-fieldset p-4">
        <legend class="bm-fieldset-legend text-lg">Ausstattung</legend>
        <ng-container [ngTemplateOutlet]="tplAusstattung" />
      </fieldset>
      <fieldset class="bm-fieldset p-4 relative">
        <legend class="bm-fieldset-legend text-lg">Adresse</legend>
        <div id="address_geocoder" class="absolute -top-8 right-4"></div>
        <ng-container [ngTemplateOutlet]="tplAdresse" />
      </fieldset>
      <div class="flex flex-row gap-2 items-center justify-end mt-6 col-span-3">
        <a [routerLink]="'/filiale/'" class="bm-btn"> Abbrechen </a>
        <button class="bm-btn bm-btn-primary" [disabled]="!canSubmit">Filiale erstellen</button>
      </div>
    </form>
  </div>
</hawk-record-navigation>

<ng-template #tplStammdaten>
  <label class="bm-fieldset-label">Store-Nr*</label>
  <input class="bm-input w-full" type="text" [formControl]="storeForm.controls.nr" />
  @if (storeForm.controls.nr.hasError('alreadyUsed')) {
    <div class="bm-alert bm-alert-error bm-alert-soft mt-1">
      Diese Store-Nr wird bereits verwendet.
      <a class="underline" [routerLink]="'/filiale/' + storeForm.controls.nr.getError('alreadyUsed').id" target="_blank">
        Zur bestehenden Filiale
      </a>
    </div>
  }

  <label class="bm-fieldset-label">Name*</label>
  <input class="bm-input w-full" type="text" [formControl]="storeForm.controls.name" />

  @if (presetFromRoute) {
    <div class="bm-alert bm-alert-warning bm-alert-soft">
      <i class="fa fa-link"></i>
      <span>
        Diese Filiale wird beim Anlegen automatisch mit
        @if (presetProjectNames.length) {
          {{ presetProjectNames.length === 1 ? "dem Projekt" : "den Projekten" }}
          <strong>{{ presetProjectNames.join(", ") }}</strong>
        } @else {
          den vorgegebenen Kunden
        }
        verknüpft. Kunden und Projekte sind deshalb gesperrt.
      </span>
      <button class="bm-btn bm-btn-ghost bm-btn-xs" type="button" (click)="clearRoutePreset()">
        Auswahl ändern
      </button>
    </div>
  }

  <label class="bm-fieldset-label">Kunden</label>
  <ng-select
    [formControl]="storeForm.controls.customer_ids"
    [items]="customers"
    [multiple]="true"
    bindLabel="name"
    bindValue="id"
  />

  <label class="bm-fieldset-label">Projekte</label>
  <ng-select
    [formControl]="storeForm.controls.project_ids"
    [items]="selectableProjects"
    [multiple]="true"
    bindLabel="name"
    bindValue="id"
    [placeholder]="
      storeForm.controls.customer_ids.value?.length
        ? 'Keine Projekt-Verknüpfung'
        : 'Erst einen Kunden auswählen'
    "
  />

  <label class="bm-fieldset-label">E-Mail</label>
  <input class="bm-input w-full" type="text" [formControl]="storeForm.controls.email" />

  <label class="bm-fieldset-label">Telefon 1</label>
  <input class="bm-input w-full" type="text" [formControl]="storeForm.controls.phone1" />

  <label class="bm-fieldset-label">Telefon 2</label>
  <input class="bm-input w-full" type="text" [formControl]="storeForm.controls.phone2" />

  <label class="bm-fieldset-label">Kommentar</label>
  <input class="bm-input w-full" type="text" [formControl]="storeForm.controls.comment" />
</ng-template>

<ng-template #tplAusstattung>
  <label class="bm-fieldset-label">Anzahl Kassen</label>
  <input class="bm-input w-full" type="number" min="0" [formControl]="storeForm.controls.register" />

  <label class="bm-fieldset-label">IP</label>
  <input class="bm-input w-full" type="text" [formControl]="storeForm.controls.ip" />
</ng-template>

<ng-template #tplAdresse>
  <label class="bm-fieldset-label">Firma</label>
  <input class="bm-input w-full" type="text" [formControl]="storeForm.controls.company" />

  <label class="bm-fieldset-label">Name</label>
  <div class="flex flex-row gap-2">
    <input
      class="bm-input w-full"
      type="text"
      [formControl]="storeForm.controls.address_firstname"
      placeholder="Vorname"
    />
    <input
      class="bm-input w-full"
      type="text"
      [formControl]="storeForm.controls.address_lastname"
      placeholder="Nachname"
    />
  </div>

  <label class="bm-fieldset-label">Straße</label>
  <input class="bm-input w-full" type="text" [formControl]="storeForm.controls.street" />

  <label class="bm-fieldset-label">PLZ / Ort</label>
  <div class="flex flex-row gap-2">
    <input class="flex-1 bm-input w-full" type="text" [formControl]="storeForm.controls.zip" placeholder="PLZ" />
    <input class="flex-2 bm-input w-full" type="text" [formControl]="storeForm.controls.city" />
  </div>

  <label class="bm-fieldset-label">Land</label>
  <input class="bm-input w-full" type="text" [formControl]="storeForm.controls.country" />

  <label class="bm-fieldset-label">Staat</label>
  <input class="bm-input w-full" type="text" [formControl]="storeForm.controls.state" />

  @if (addressDuplicateCheckLoading) {
    <div class="mt-2 text-sm text-gray-500">Prüfe auf Duplikate...</div>
  }
  @if (addressDuplicates.length > 0) {
    <div class="bm-alert bm-alert-warning bm-alert-soft mt-2">
      <div class="flex items-center gap-2 flex-wrap">
        <span>Mögliches Duplikat:</span>
        <a class="underline" [routerLink]="'/filiale/' + addressDuplicates[0].id" target="_blank">{{ addressDuplicates[0].nr }} - {{ addressDuplicates[0].name }}</a>
        @if (addressDuplicates.length > 1) {
          <button type="button" class="underline" (click)="showDuplicateModal = true">... und {{ addressDuplicates.length - 1 }} weitere</button>
        }
      </div>
    </div>
  }
</ng-template>

@if (showDuplicateModal) {
  <dialog class="bm-modal" open>
    <div class="bm-modal-box">
      <h3 class="text-lg font-bold mb-4">Mögliche Duplikate ({{ addressDuplicates.length }})</h3>
      <ul class="flex flex-col gap-2">
        @for (store of addressDuplicates; track store.id) {
          <li class="flex flex-col">
            <a class="underline font-medium" [routerLink]="'/filiale/' + store.id" target="_blank">{{ store.nr }} - {{ store.name }}</a>
            <span class="text-xs opacity-70">{{ store.address }}</span>
          </li>
        }
      </ul>
      <div class="flex justify-end mt-4">
        <button class="bm-btn" (click)="showDuplicateModal = false">Schließen</button>
      </div>
    </div>
  </dialog>
}

@if (showConfirmModal) {
  <dialog class="bm-modal" open>
    <div class="bm-modal-box">
      <h3 class="text-lg font-bold mb-4">Filiale erstellen</h3>
      <p>Es existiert bereits mindestens eine Filiale für diese Adresse. Möchtest du die Filiale <strong>{{ storeForm.controls.nr.value }}</strong> wirklich erstellen?</p>
      <div class="flex justify-end gap-2 mt-4">
        <button class="bm-btn" (click)="showConfirmModal = false">Abbrechen</button>
        <button class="bm-btn bm-btn-primary" (click)="confirmCreate()">Erstellen</button>
      </div>
    </div>
  </dialog>
}
